// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"210cc704","157":"471d34d5","371":"3730ce01","423":"6359dbbe","453":"b70f62b0","595":"f30d3541","750":"52ed60f7","842":"bff8675a","928":"9f9b420b","988":"cac51888"}[chunkId] + ".chunk.js";
};